// Height of the sticky TopBar. Page shells subtract it from the viewport and
// the SideBar reserves it as a spacer, so it lives here rather than in the
// TopBar component to keep layout code from importing a UI component.
export const TOP_BAR_HEIGHT_PX = 72;
export const TOP_BAR_HEIGHT = `${TOP_BAR_HEIGHT_PX}px`;

// A payment reminder / outstanding-payment banner rendered directly under it.
export const BANNER_HEIGHT_PX = 58;

// Viewport height left for page content, with and without a banner showing.
export const CONTENT_HEIGHT = `calc(100vh - ${TOP_BAR_HEIGHT_PX}px)`;
export const CONTENT_HEIGHT_WITH_BANNER = `calc(100vh - ${
  TOP_BAR_HEIGHT_PX + BANNER_HEIGHT_PX
}px)`;
